export default __webpack_public_path__ + "static/media/cohort-unlock.449bc808.svg";